import React from 'react'
import { connect } from 'react-redux'
import { brand } from '@r/app-selectors'
import { TruArrow } from '@uswitch/spark-icons/tru'
import Icon from '../icon'

interface ButtonProps {
  dataClickTracking?: any
  dataAction?: string
  disabled?: boolean
  variant?: 'primary' | 'secondary' | 'tertiary' | 'icon'
  size?: 'lg' | 'md' | 'sm' | 'mdTriage'
  type?: 'submit' | 'reset' | 'button'
  style?: object
  brand: 'money' | 'uswitch'
  children: React.ReactNode
  withIcon?: boolean
  href?: string
  onClick?: any
  openInNewTab?: boolean
  position?: number
}

const Button = ({
  dataClickTracking = {},
  dataAction,
  disabled = false,
  variant = 'primary',
  size = 'lg',
  type = 'button',
  style = {},
  brand,
  children,
  withIcon,
  href,
  onClick,
  openInNewTab,
  position,
}: ButtonProps) => {
  const IconComponent = () => {
    return (
      <div className='icon_atom' data-fs-product-table={`cta-${position}`}>
        <Icon
          color={brand === 'money' ? '#FEAF00' : '#141424'}
          glyph={brand === 'money' ? 'right-arrow-button' : 'right-arrow-button-uswitch'}
          size={brand === 'money' ? 45 : 36}
        />
      </div>
    )
  }

  const iconClass = withIcon ? 'button_atom_icon' : ''

  const component = () =>
    variant === 'icon' ? (
      <IconComponent />
    ) : (
      <button
        type={type}
        className={`button_atom button_atom__${variant} button_atom__${size} ${iconClass}`}
        disabled={disabled}
        data-click-tracking={JSON.stringify(dataClickTracking)}
        data-action={dataAction}
        style={style}
        onClick={onClick}
        data-fs-product-table={`cta-${position}`}
      >
        {children}
        {withIcon && <TruArrow className='button_icon' />}
      </button>
    )

  return href ? (
    <a
      className='button_link'
      href={href}
      data-click-tracking={JSON.stringify(dataClickTracking)}
      target={openInNewTab ? '_blank' : undefined}
      rel='noreferrer'
      data-fs-product-table={`cta-${position}`}
    >
      {variant === 'icon' ? (
        <IconComponent />
      ) : (
        <div
          className={` button_atom button_atom_link button_atom__${variant} button_atom__${size} ${iconClass}`}
          style={style}
        >
          {children}
          {withIcon && <TruArrow className='button_icon' />}
        </div>
      )}
    </a>
  ) : (
    component()
  )
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(Button)
